import React from 'react';

import { ContentContainer, MainContainer, Title } from './styles';
import AdminMenu from '../../../../../../components/Admin/MenuDetalhes/AdminMenu';

export default function Container({ children }) {
  return (
    <MainContainer>
      <AdminMenu />
      <ContentContainer>
        <Title>Certificados Gerados</Title>
        {children}
      </ContentContainer>
    </MainContainer>
  )
}